import {action, Action} from 'easy-peasy';

interface UserLogin {
    id: number;
    user_id: number;
    login_time: string;
    logout_time?: string;
    ip_address?: string;
    user_agent?: string;
}

interface UserLoginsState {
    activeUser: number;
    setActiveUser: Action<UserLoginsState, number>;
    items: UserLogin[];
    loadUserLogins: Action<UserLoginsState, UserLogin[]>;
    searchPagesList: number[];
    setSearchPagesList: Action<UserLoginsState, number[]>;
    searchCurrentPage: number;
    setSearchCurrentPage: Action<UserLoginsState, number>;
    loading: boolean;
    setLoading: Action<UserLoginsState, boolean>;
}

const userLoginsStore: UserLoginsState = {
    activeUser: 0,
    setActiveUser: action((state, activeUser) => {
        state.activeUser = activeUser;
    }),
    items: [],
    loadUserLogins: action((state, userLoginsList) => {
        state.items = userLoginsList;
    }),
    searchPagesList: [],
    setSearchPagesList: action((state, searchPagesList) => {
        state.searchPagesList = searchPagesList;
    }),
    searchCurrentPage: 1,
    setSearchCurrentPage: action((state, searchCurrentPage) => {
        state.searchCurrentPage = searchCurrentPage;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
};

export default userLoginsStore; 